module.exports = __webpack_public_path__ + "img/city7.cd3dd360.png";